<template>
<div class="container">
    <div class="row pb-1 d-flex align-items-end justify-content-end">
        <div class="col-8">
            <h3 class="c-ndarkthree bold">
                <CompanyIcon :color="getPrimaryColorHex.four"/> Empresas | 
                <span>{{ companyTypeName | formatName}}</span>
            </h3>
            <p class="c-ndarkfour">
                Visualize todas as empresas cadastradas na plataforma.
            </p>
        </div>
        <div class="col-4 mt-4 d-flex align-items-center justify-content-end" >
            <Button type="primary" @click="handleNewCompanyButtonClick"  :color="getPrimaryColor" v-if="!USER_TYPE_MIXIN.isBackOffice && companyType == 0">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.99983 1V9M1 5H8.99967" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Nova empresa
            </Button>
        </div>
    </div>
    <div class="row">
        <div class="col-8" :class="companyType === '2' ? 'min-height-100' : ''">
            <TabCompany :isSponsor="companyType === '0'" @update-tab="paginationNextAndPrev(1)" v-if="companyType !== '2'"/>
        </div>
        <div class="col-4 d-flex align-items-center justify-content-end">
            <CompanyFilter
                :filtersProp="filters"
                :filterSearchProp="filterQuery"
                :dataFilter="companyType === '1'"
                :statusFilter="false"
                :companyTypeFilter="false"
                :economicGroupPartnerFilter="!USER_TYPE_MIXIN.isBackOffice"
                :attachedContractFilter="companyType === '1' && !USER_TYPE_MIXIN.isBackOffice"
                :economicGroupFilter="companyType !== '0'"
                :showFilterButton="companyType !== '0'"
                @filter="filters = $event; paginationNextAndPrev(1)"
                @filterSearch="filterQuery = $event; paginationNextAndPrev(1)"
                @emptyFilter="filterQuery = ''; filters = $event; paginationNextAndPrev(1)"

            />
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <TableLoading v-if="isLoading" class="mt-3"/>
            <CompanyCashforce
                v-else-if="$store.state.companies.companies.length"
                :tableData="$store.state.companies.companies"
                :companyType="companyType"
                :partners="partners"
                @changeIsActive="handleChangeIsActive($event)"
                @sucessSendReview="requestUpdate"
                @persistFilter="persistFilter"
                @changedCanOperate="handleChangedCanOperate"
            />
            <NotFound v-else />
        </div>
    </div>
    <PaginationButtons :pagination="$store.state.companies.companiesPagination" @next="paginationNextAndPrev($event)" @prev="paginationNextAndPrev($event)"/>
    <NewCompany :dialogVisible="dialogVisible" :companyType="companyType" @closeModal="dialogVisible = $event"/>
    <CompanyDelete :dialogVisible="deleteDialogVisible" @closeModal="deleteDialogVisible = $event" @confirmDelete="requestCompanyIsActiveChange"/>
</div>
</template>

<script>
import PaginationButtons from '@/components/pagination/PaginationButtons'
import CompanyCashforce from '@/components/tables/CompanyCashforce'
import CompanyFilter from '@/components/filters/CompanyFilter'
import getCompanies from '@/api/getCompanies'
import CompanyDelete from '@/components/modals/CompanyDelete'
import NewCompany from '@/components/modals/NewCompany.vue'
import NotFound from '@/components/emptyOrNotFound/NotFound'
import TabCompany from '@/components/tabs/TabCompany.vue'
import removeDotsAndBars from '@/utils/removeDotsAndBars'
import updateCompany from '@/api/updateCompany'
import TableLoading from '@/components/loading/TableLoading'
import store from '@/store'

export default {
    components: {
        PaginationButtons,
        CompanyCashforce,
        CompanyFilter,
        CompanyDelete,
        NewCompany,
        NotFound,
        TabCompany,
        TableLoading
    },
    data() {
        return {
            filters: {
                registerSituation: '',
                filterDate: {
                    start: null,
                    end: null
                },
                companyPartner: '',
                attachedContract: '',
                expirationDate: {
                    start: null,
                    end: null
                },
                economicGroup: ''
            },
            pagination: 1,
            companyToActiveChange: {},
            dialogVisible: false,
            deleteDialogVisible: false,
            filterQuery: '',
            isLoading: false,
            partners: []
        }
    },
    computed: {
        filterDate() {
            const dateStart = this.filters.filterDate.start ? this.filters.filterDate.start.split('/') : ''
            const dateEnd = this.filters.filterDate.end ? this.filters.filterDate.end.split('/') : ''
           
            return {
                dateInit: dateStart.length > 2 ? `${dateStart[2]}-${dateStart[1]}-${dateStart[0]}` : '',
                dateEnd: dateEnd.length > 2 ? `${dateEnd[2]}-${dateEnd[1]}-${dateEnd[0]}` : '',
            }
        },
        expirationDate() {
            const dateStart = this.filters.expirationDate.start ? this.filters.expirationDate.start.split('/') : ''
            const dateEnd = this.filters.expirationDate.end ? this.filters.expirationDate.end.split('/') : ''

            return {
                dateInit: dateStart.length > 2 ? `${dateStart[2] - 1}-${dateStart[1]}-${dateStart[0]}` : '',
                dateEnd: dateEnd.length > 2 ? `${dateEnd[2] - 1}-${dateEnd[1]}-${dateEnd[0]}` : '',
            }
        },
        companyType() {
            const companyTypes = {
                sponsor: '0',
                provider: '1',
                buyer: '2'
            }

            const companyType = this.$route.path.split('/company/')[1]

            return companyTypes[companyType]
        },
        companyTypeName() {
            const companyTypes = {
                sponsor: 'Financiador',
                provider: 'Cedente',
                buyer: 'Sacado'
            }

            const companyType = this.$route.path.split('/company/')[1]

            return companyTypes[companyType]
        },
        activeTab() {
            return this.$store.state.tabs.companyTab
        }
    },
    watch: {
        pagination(value) {
            this.$store.commit('pages/setCompanies', parseInt(value))
        }
    },
    methods: {
        persistFilter(){
            this.$store.commit('filters/setPersistentFilter', this.filters)
            this.$store.commit('filters/setPersistentFilterQuery', this.filterQuery)
        },
        async handleChangedCanOperate() {
            await this.requestUpdate(this.pagination, '1')
        },
        handleChangeIsActive(companyToChange) {
            this.companyToActiveChange = companyToChange
            if (companyToChange.active == false) this.deleteDialogVisible = true
            else this.requestCompanyIsActiveChange()
        },
        async requestCompanyIsActiveChange() {
            this.deleteDialogVisible = false
            const result = await updateCompany(this.companyToActiveChange.cnpjId, { registerActive: this.companyToActiveChange.active })
            if (result.ok) {
                //await getCompanies(1, '', this.activeTab);
                await this.requestUpdate(this.pagination, this.companyType)
                if (this.companyToActiveChange.active == true) {
                    this.$notify({
                        title: 'Empresa ativada com sucesso!',
                        message: '',
                        type: 'success',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                    });
                }
            }
        },
        async requestUpdate(page, companyType) {
            this.isLoading = true

            // TODO: Rethink this. Palliative solution
            if (!page && !companyType){
                await this.requestUpdate(this.pagination, this.companyType)
                return
            }

            const result = await getCompanies({
                page: page,
                companyType: companyType,
                registerComplete: companyType !== '2' ? this.activeTab : null, // Buyers always show all companies
                query: removeDotsAndBars(this.filterQuery),
                dateInit: this.filterDate.dateInit,
                dateEnd: this.filterDate.dateEnd,
                partner: this.filters.companyPartner,
                attachedContract: this.filters.attachedContract,
                expirationInit: this.expirationDate.dateInit,
                expirationEnd: this.expirationDate.dateEnd,
                economicGroupId: this.filters.economicGroup,
                isActive: true
            })

            if (!result.data.ok && result.data.message == "invalid page number" && this.pagination != 1) {
                this.pagination = 1
                await this.requestUpdate(1, companyType)
            }
            this.isLoading = false
        },
        async paginationNextAndPrev(page) {
            this.pagination = page
            //await getCompanies(page, this.filters.companyType, this.activeTab, removeDotsAndBars(this.filterQuery), this.filterDate.dateInit, this.filterDate.dateEnd);
            this.requestUpdate(page, this.companyType)
        },
        handleNewCompanyButtonClick() {
            this.gotoNewCompany()

            // if (this.USER_TYPE_MIXIN.isBackOffice) {
            //     this.gotoNewCompany()
            // } else {
            //     this.dialogVisible = true
            // }
        },
        gotoNewCompany() {
            this.$router.push(`/company/new/${this.companyType}`)
        }
    },
    beforeRouteEnter(to, from, next) {
        store.commit('filters/setBeforePathEnter', from.path)
        next();
    },
    async created() {
        const defaultTab = '-1'
        this.$store.commit('tabs/setCompanyTab', defaultTab)
        
        const { state: { 
                filters: { persistentFilter, persistentFilterQuery, beforePathEnter },
        } } = this.$store
        const updatePathProvider = "/provider/update/"
        const updatePathBuyer = "/buyer/update/"
        const updatePathSponsor = "/sponsor/update/"// TODO: Try to not return this "manually"
        const cameFromUpdate = (beforePathEnter.includes(updatePathProvider) || beforePathEnter.includes(updatePathBuyer) || beforePathEnter.includes(updatePathSponsor))

        if (cameFromUpdate) {
            this.filters = persistentFilter
            this.filterQuery = persistentFilterQuery
            this.pagination = this.$store.state.pages.companies
        } else {
            this.$store.commit('filters/setPersistentFilter', {})
            this.$store.commit('filters/setPersistentFilterQuery', '')
            this.pagination = 1
        }
        // await getCompanies(this.$store.state.pages.companyPage, '', this.$store.state.tabs.companyTab);
        this.requestUpdate(this.pagination, this.companyType)
        this.$store.commit('register/resetCompany')
    }
}
</script>

<style lang="scss" scoped>
.min-height-100 {
    min-height: 100px;
}
</style>
